module.exports = __webpack_public_path__ + "static/media/logo-grc.2e4f276e.svg";